module.exports = __webpack_public_path__ + "img/logo.b05efaf8.svg";